import { memo } from 'react';
import { Navigate } from 'react-router-dom';

const NotFound = memo(() => {
  return <Navigate to="/" />;
});

NotFound.displayName = 'NotFound';
export default NotFound;
